module.exports = __webpack_public_path__ + "assets/next-passive.7ebcf465.svg";